<template>
    <chart-card>
        <template slot="header">
            <h4 class="card-title">Casos por Sexo</h4>
            <p class="card-category">Casos segmentados entre os sexos</p>
        </template>
        <template slot="footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock-o"></i> Ultima atualização: {{lastUpdatedFormated}}
            </div>
        </template>
        <apexchart type="pie" ref="chart" height="363" :options="chartOptions" :series="series"></apexchart>
    </chart-card>
</template>

<script>
    import ChartCard from "@/components/ChartCard";
    import moment from "moment";
    export default {
        name: "PieByGender",
        components: {ChartCard},
        props: ['chartData','lastUpdated'],
        computed:{
            lastUpdatedFormated (){
                return moment(this.lastUpdated, 'YYYY-MM-DD').format('DD/MM/YYYY [às] HH:mm:ss')
            }
        },
        watch:{
            chartData(){
                var self = this;
                this.chartData.forEach(function (data) {
                    self.series.push(data.cases)
                    self.chartOptions.labels.push(data.gender)
                });
            }
        },
        data: function () {
            return {
                series: [],
                chartOptions: {
                    colors:['#4628f4', '#f44b68', '#b6b1be'],
                    chart: {
                        width: 360,
                        type: 'pie',
                    },
                    labels: [],
                },
            }
        }
    }
</script>

<style scoped>

</style>